function MotherCityLogo() {
  return (
    <img
      height="200"
      width="200"
      src="/logos/mother-city-logo.png"
      className="w-full h-full object-contain max-md:py-8"
      alt="Mother in the City Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { MotherCityLogo };
